import { useContext, useState } from "react";
import SelectInput from "../../components/SelectInput/SelectInput";

import './styles.css';

import FileInput from "../components/FileInput/FileInput";
import DownloadModel from "../components/DownloadModel/DownloadModel";

import tryExportingResults from "../exports/results";
import tryImportingResults from "../imports/results";

import useFetchAllDraws from "../hooks/useFetchAllDraws";
import useAuthAdmin from "../hooks/useAuthAdmin";
import useSetPageTitle from "../../hooks/useSetPageTitle";

import DefaultLoader from "../../components/Loader/DefaultLoader";
import LinearLoader from "../../components/Loader/LinearLoader";
import AdminContext from "../contexts/AdminContext";

function ResultsAdmin() {
    const { currentPromo } = useContext(AdminContext);

    useAuthAdmin();
    useSetPageTitle('Admin');
    
    const [draw, setDraw] = useState('');
    const { drawsOption } = useFetchAllDraws(currentPromo?.id);

    const [file, setFile] = useState(null);
    const [loadingImport, setLoadingImport] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [errorImport, setErrorImport] = useState([]);
    const [errorExport, setErrorExport] = useState('');
    const [successImport, setSuccessImport] = useState('');

    const downloadModel = () => {
        const link = document.createElement('a');
        link.href = "/models/modelo-resultados.csv";
        link.download = "modelo-resultados.csv";
        link.click();
    };

    return(
        <>
            <div className="admin-page-container">
                <div className="admin-page-title-container">
                    <p className="admin-page-title">Importar números da sorte premiados</p>
                    {
                        localStorage.getItem('role') !== '1' ?
                        <DownloadModel label="Baixe o modelo de planilha" onClick={downloadModel} />
                        : false
                    }
                </div>
                {
                    localStorage.getItem('role') !== '1' ?
                        <>
                            <div className="admin-page-select-input-container">
                                <SelectInput
                                    options={drawsOption.map(el => ({ label: `Sorteio ${el.tipo.charAt(0).toUpperCase() + el.tipo.slice(1)} - ${el.data.replaceAll('-', '/')}`, value: el.id }))}
                                    value={drawsOption.filter(option => option.value === draw)[0]}
                                    setOption={(value) => {
                                        setDraw(value.value);
                                    }}
                                    rubik
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }} />
                            <FileInput setValue={setFile} />
                            <div className="admin-page-button-container">
                                    <button className="admin-page-primary-button" onClick={() => tryImportingResults(currentPromo?.id, file, draw, setLoadingImport, setErrorImport, setSuccessImport)}>Enviar</button><br />
                                { loadingImport ? <DefaultLoader /> : false }
                            </div>
                            <p className="admin-page-success-import">{successImport}</p>
                            {errorImport.length > 0 &&
                                <div className="admin-page-error-list">
                                    <h3>Erros:</h3>
                                    {errorImport.map(e => <p key={e.row} className="admin-page-error-import">#{e.row} - {e.message}</p>)}
                                </div>
                            }
                        </>
                        : false
                }
                <div className="admin-page-export-container">
                    <button className="admin-page-secundary-button" onClick={() => tryExportingResults(currentPromo?.id, setLoadingExport, setErrorExport)}>Baixar resultados <span className="button-bold">atuais</span></button>
                    { loadingExport ? <LinearLoader /> : false }
                </div>
                <p className="admin-page-error-import">{errorExport}</p>
            </div>
        </>
    )
}

export default ResultsAdmin;